exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sent-buttons .left[data-v-688a719f]{position:absolute;left:15px}@media (max-width:575px){.sent-buttons[data-v-688a719f]{width:100%}.sent-buttons .left[data-v-688a719f]{position:relative;left:0;display:block;width:100%}.sent-buttons .btn-xs-block[data-v-688a719f]{width:100%}}", ""]);

// exports
